import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/images/psp/PDI/right_eye.svg'
import _imports_1 from '../../../../assets/images/psp/PDI/left_eye.svg'
import _imports_2 from '../../../../assets/images/psp/PDI/face.svg'
import _imports_3 from '../../../../assets/images/psp/PDI/top_head.svg'


const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "PDI-image-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "PDI-image right_eye" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1 /* HOISTED */)
const _hoisted_4 = { class: "PDI-image-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "PDI-image left_eye" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"PDI-image-wrapper\"><div class=\"PDI-image face\"><img src=\"" + _imports_2 + "\" alt=\"\"></div></div><div class=\"PDI-image-wrapper\"><div class=\"PDI-image top_head\"><img src=\"" + _imports_3 + "\" alt=\"\"></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    id: `PDI-asnwers-${_ctx.step_id}`,
    class: "PDI-asnwers"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('feature.surveys.PDI.right_eye')) + " ", 1 /* TEXT */),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$t('feature.surveys.PDI.left_eye')) + " ", 1 /* TEXT */),
      _hoisted_5
    ]),
    _hoisted_6
  ], 8 /* PROPS */, _hoisted_1))
}